import React, { useState, Component } from 'react';
import TextBox from '../Atoms/TextBox';
import MediaCard from '../Molecules/MediaCard';

import { Link } from 'react-router-dom'


// function Card() {
  
//     let [toggle, setToggle] = useState(false);

//     const onToggleChange = (checked) => {
//       setToggle(checked);
//   }
//     // minw-25vw 
//     return <div className="card flex wrap">
//       <MediaCard />
//       <TextBox firstLevel="p" secondLevel="i" thirdLevel="p" cx="" border="br bb"/>
//     </div>
    
    
//     // <div className="w-90 bb flex br-medium items-bottom hidden">
//     //     <img className="w-100" src="images/featured-image.jpg" alt="Featured Work"/>
//     //     <TextBox firstLevel="p" secondLevel="i" thirdLevel="p" cx="pa-m pos-absolute "/>
//     //   </div>
    
  
// }

// export default Card;



/////// /////// /////// /////// /////// /////// /////// /////// /////// /////// /////// /////// /////// 
  /////// /////// /////// /////// /////// /////// /////// /////// /////// /////// /////// /////// /////// 


class Card extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);
   
    this.state = {
      isHovered: false,
      cardData: {},
      title: ''
    };

    // This binding is necessary to make `this` work in the callback
    this.handleHover = this.handleHover.bind(this);
  }

  handleHover = () => this.setState({ isHovered: !this.state.isHovered });
  
  static getDerivedStateFromProps(props, state) {
    return {
      cardData: props.data
     };
  }





    // //this is where we receive API calls inside components
    // componentDidMount() {
    //   const itemData = this.props.data
    // }

    // if (this.props.data.fields) {
    //   console.log('okok')
    // }

  render() {
    const {cx, borderTextBox, borderMediaCard, data} = this.props;
    const {cardData} = this.state
    
    // console.log(data)
    // console.log(this.state.cardData)
    
    
    let layout;
    if (cardData) {
      layout = 
      // <Link to={`/post/${cardData.sys.id}`} className={`card flex wrap height-fit hover-animation phone-height-400 phone-center ${cx} ${this.state.isHovered ? "bg-hover" : ""} `} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}></Link>
        <Link to={`/post/${cardData.sys.id}`} className={`card flex wrap height-fit hover-animation phone-center ${cx} ${this.state.isHovered ? "bg-hover" : ""} `} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
          <MediaCard hoverRadius={`${this.state.isHovered ? "large" : "100"}`} border={borderMediaCard} url={`${cardData.fields.thumbnail.fields.file.url}?w=600&h=600&fm=jpg&fl=progressive`} category={cardData.metadata.tags[0] ? cardData.metadata.tags[0].sys.id : '-' } chipLink={this.props.chipLink}/>
          <TextBox firstLevel="h2" secondLevel="i" thirdLevel="p" cx="phone-w-250 phone-bl phone-br phone-bb" border={borderTextBox} firstContent={`${cardData.fields.title} (${cardData.fields.year})`} secondContent={cardData.fields.titleEnglish} thirdContent={cardData.fields.exhibitionPlace}/>
        </Link>;
    } else {
      layout = <p>...</p>;
    }


    return(<div className="dc">
      {layout}
    </div>
    
    );
    


  }
}


export default Card;    




/////

    // if (data === undefined) (
    //   console.log('😓')
    // )
    // else {
    //   console.log('🎉')
    //   console.log(data.fields)
    // }


    // return (<a className={`card flex wrap height-fit hover-animation ${cx} ${this.state.isHovered ? "bg-hover" : ""} `} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
    //   <MediaCard hoverRadius={`${this.state.isHovered ? "large" : "100"}`} border={borderMediaCard} url={cardData ? cardData.fields.thumbnail.fields.file.url : ''}/>
    //   <TextBox firstLevel="p" secondLevel="i" thirdLevel="p" cx="" border={borderTextBox}/>
    //   <h1>{cardData ? cardData.fields.title : ''}</h1>
    // </a>


    // );

    //todo: https://reactjs.org/docs/conditional-rendering.html
    //wrap each component in ifelse op.?
    //creating boolean components in render?
    
      
    //   return (<a className={`card flex wrap height-fit hover-animation ${cx} ${this.state.isHovered ? "bg-hover" : ""} `} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
    //   <MediaCard hoverRadius={`${this.state.isHovered ? "large" : "100"}`} border={borderMediaCard} url={cardData ? cardData.fields.thumbnail.fields.file.url : ''}/>
    //   <TextBox firstLevel="p" secondLevel="i" thirdLevel="p" cx="" border={borderTextBox}/>
    //   <h1>{cardData ? cardData.fields.title : ''}</h1>
    // </a>
    ///////

// <div className="br bb flex  justify-between ">
//   <a className={`hover-animation flex wrap h-9 pl-m pt-s ${this.state.isHovered ? "bg-hover" : ""} `} onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
//     <div className="">
//       <h3>Fernisering 08.08.2021</h3>
//       <p>Nōmen ā solemnibus trahit Solemniacum;</p>
//     </div>
//     <div className="flex items-bottom pb-s">
//       <small>Thu Jul 20 2017 06:07:30</small>
//     </div>
//   </a>
// </div>